import { QueryClient } from '@tanstack/react-query';

// Central cache/query config. Short staleTime keeps lists feeling instant
// (stale-while-revalidate) without hammering the backend on every render —
// see the v6 architecture doc §7 performance strategy.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
